"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_FAILURE = exports.SUBMIT_SUCCESS = exports.SUBMIT_REQUEST = exports.SELECT_STEP = exports.NEXT_STEP = exports.RESET_STEP = exports.FINISH_STEP = exports.RESET_FORM_DATA = exports.FORM_DATA = exports.CONFIGURE = undefined;
exports.configure = configure;
exports.submitFormData = submitFormData;
exports.resetFormData = resetFormData;
exports.finishStep = finishStep;
exports.selectNextStep = selectNextStep;
exports.selectStep = selectStep;
exports.submitReservation = submitReservation;

var _api = require("../middleware/api");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CONFIGURE = exports.CONFIGURE = "CONFIGURE";

function configure(formSteps, summarySteps, initialData) {
  return {
    type: CONFIGURE,
    formSteps: formSteps,
    summarySteps: summarySteps,
    initialData: initialData
  };
}

var FORM_DATA = exports.FORM_DATA = "FORM_DATA";

function submitFormData(data) {
  return {
    type: FORM_DATA,
    data: data
  };
}

var RESET_FORM_DATA = exports.RESET_FORM_DATA = "RESET_FORM_DATA";

function resetFormData() {
  return {
    type: RESET_FORM_DATA
  };
}

var FINISH_STEP = exports.FINISH_STEP = "FINISH_STEP";

function finishStep(step) {
  return function (dispatch) {
    switch (step) {
      case "garage":
        dispatch(resetStep("service"));
        dispatch(resetStep("timeslot"));
        break;

      case "service":
        dispatch(resetStep("timeslot"));
        break;
    }

    return dispatch({
      type: FINISH_STEP,
      step: step
    });
  };
}

var RESET_STEP = exports.RESET_STEP = "RESET_STEP";

function resetStep(step) {
  return {
    type: RESET_STEP,
    step: step
  };
}

var NEXT_STEP = exports.NEXT_STEP = "NEXT_STEP";

function selectNextStep() {
  return {
    type: NEXT_STEP
  };
}

var SELECT_STEP = exports.SELECT_STEP = "SELECT_STEP";

function selectStep(step) {
  return {
    type: SELECT_STEP,
    step: step
  };
}

var SUBMIT_REQUEST = exports.SUBMIT_REQUEST = "SUBMIT_REQUEST";
var SUBMIT_SUCCESS = exports.SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
var SUBMIT_FAILURE = exports.SUBMIT_FAILURE = "SUBMIT_FAILURE";

function submitReservation() {
  return function (dispatch, getState) {
    var _getState = getState(),
        formData = _getState.formData;

    var dateUT = formData.day.setHours(formData.hour, formData.minute) / 1000;
    var requestData = {
      Mode: 2,
      BookingDateUT: dateUT,
      GarageId: formData.garageId,
      PersonalData: {
        FirstName: formData.firstName,
        LastName: formData.lastName,
        AdditionalName: formData.company,
        Mail: formData.email,
        Phone: formData.phone,
        IsCustomer: formData.isCustomer,
        ReminderMail: formData.reminderMail,
        ReminderSms: formData.reminderSMS,
        Message: formData.message
      },
      Services: formData.serviceIds.map(function (serviceId) {
        return {
          Id: serviceId,
          Answers: !formData.answers.hasOwnProperty(serviceId) ? [] : Object.keys(formData.answers[serviceId]).map(function (questionId) {
            return {
              QuestionId: questionId
            };
          })
        };
      }),
      Vehicle: {
        BrandId: formData.brandId,
        ModelId: formData.modelId,
        TypeId: formData.typeId,
        Registered: formData.registerDate,
        Mileage: formData.mileage,
        LicencePlate: formData.licensePlate,
        Fin: formData.fin
      },
      MobilityOptionId: formData.mobilityId
    };
    return dispatch(_defineProperty({}, _api.CALL_API, {
      types: [SUBMIT_REQUEST, SUBMIT_SUCCESS, SUBMIT_FAILURE],
      endpoint: "/apps/hpmodule/serviceBooking/save",
      method: "POST",
      authenticated: true,
      body: requestData
    }));
  };
}